import { Amplify } from 'aws-amplify';
import {
  signIn as amplifySignIn,
  confirmSignIn as amplifyConfirmSignIn,
  signOut as amplifySignOut,
  fetchAuthSession,
  getCurrentUser,
  type SignInOutput,
} from 'aws-amplify/auth';
import { env } from '@/config';

let configured = false;

export function configureAuth() {
  if (configured) return;
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.userPoolId,
        userPoolClientId: env.userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
  configured = true;
}

export async function startSignIn(email: string): Promise<SignInOutput> {
  configureAuth();
  return amplifySignIn({
    username: email,
    options: { authFlowType: 'CUSTOM_WITHOUT_SRP' },
  });
}

export async function submitOtp(code: string): Promise<SignInOutput> {
  configureAuth();
  return amplifyConfirmSignIn({ challengeResponse: code });
}

export async function signOut(): Promise<void> {
  configureAuth();
  await amplifySignOut();
}

export async function getIdToken(): Promise<string | null> {
  configureAuth();
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export async function getCurrentUserSafe() {
  configureAuth();
  try {
    const u = await getCurrentUser();
    const session = await fetchAuthSession();
    const claims = session.tokens?.idToken?.payload ?? {};
    const groupsClaim = (claims['cognito:groups'] as string[] | undefined) ?? [];
    const isAdmin = claims['custom:is_admin'] === 'true' || claims['custom:is_admin'] === true;
    return {
      sub: u.userId,
      email: (claims.email as string | undefined) ?? u.signInDetails?.loginId ?? '',
      groups: groupsClaim,
      isAdmin,
      isGuildMember: isAdmin || groupsClaim.includes('guild-members'),
    };
  } catch {
    return null;
  }
}
